import { render, staticRenderFns } from "./ChoosePlanPrice.vue?vue&type=template&id=7a5ab92e&scoped=true&"
import script from "./ChoosePlanPrice.vue?vue&type=script&lang=ts&"
export * from "./ChoosePlanPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5ab92e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow,VSpacer})
